import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { forgotPassword, signin, signup } from "./firebase";
import "./login-page.css";
import "./placeholder.css";
import "./loading.css";
import Cookies from "js-cookie";

const loadingIcon = () => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <div className="loading-text">Loading...</div>
    </div>
  );
};


const LoginPage = (props) => {
  const [loginState, setLoginState] = useState(Boolean(Cookies.get("loggedInBefore")) || false);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [snuId, setSnuId] = useState("");
  const [mobile, setMobile] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  let history = useHistory();

  useEffect(async () => {
    try {
      if ('firebase:authUser:AIzaSyCCxX4y8SwTmRNIJca6ms0v-T7O_FCQm0w:[DEFAULT]' in localStorage) {
        let user = localStorage.getItem('firebase:authUser:AIzaSyCCxX4y8SwTmRNIJca6ms0v-T7O_FCQm0w:[DEFAULT]');
        user = JSON.parse(user);
        if (((Date.now() - parseInt(user.lastLoginAt)) / (24 * 60 * 60 * 1000) < 30)) {
          history.push('/store');
        }
      }
      // console.log(user);
    } catch (err) {
      console.log(err)
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    let res = await signin(snuId, password);
    if (res.error) {
      alert(res.error.message);
    } else {
      setSnuId("");
      setPassword("");
      // console.log(res);
      // const token = res.user.accessToken;
      // let aa='eyJhbGciOiJSUzI1NiIsImtpZCI6ImM4MjNkMWE0MTg5ZjI3NThjYWI4NDQ4ZmQ0MTIwN2ViZGZhMjVlMzkiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZGVsaWJ1ZGR5LTg0ZWE4IiwiYXVkIjoiZGVsaWJ1ZGR5LTg0ZWE4IiwiYXV0aF90aW1lIjoxNjgxMjkzNTU3LCJ1c2VyX2lkIjoiUklZa05iSUFEaFBaZnlwcjhxdkRNekRidDAwMiIsInN1YiI6IlJJWWtOYklBRGhQWmZ5cHI4cXZETXpEYnQwMDIiLCJpYXQiOjE2ODEyOTM1NTcsImV4cCI6MTY4MTI5NzE1NywiZW1haWwiOiJzczg3OEBzbnUuZWR1LmluIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsic3M4NzhAc251LmVkdS5pbiJdfSwic2lnbl9pbl9wcm92aWRlciI6InBhc3N3b3JkIn19.Z17n_X7kDVn_BsaXhw_ghgENtozjohpaN16n0UXHUEkDlosLRnguG9jx-_eIgBrC_che24Owod45BRnLVXzz7PygZRv8O19mvW6kRzZ5QfC65PA5xh2VmNGXpudIsXoklC1QuOIPT8lIBjfrrPgP-eDkV4D405Upm6ppEXZSLhFtJ0I-pW7aAXPj0l-JywOY1FocyB3l96eG8B24Gv8jhC2f3SSzWqxH-ZW4UWheAsKYLQqmt9CqEG9JGG_YjvLqYXX-Go7zL0bws1pgCGVFApRPBxZsVh4FeCPSxNLBxEovzqFi3lBu3Zo73bi6YMjLpAEQ3dSy0Z3nNJLc4EO4Gw'
      // Cookies.set('0_k6n.l9fffp0gqw', aa, {
      //   // domain: "3.108.120.207",
      //   // httpOnly: true,
      // });
      // Cookies.set(generateRandomString(12), jumbleLetters(token), {
      //   // domain: "3.108.120.207",
      //   // httpOnly: true,
      // });
      // Cookies.set(generateRandomString(12), jumbleLetters(token), {
      //   // domain: "3.108.120.207",
      //   // httpOnly: true,
      // });
      Cookies.set("loggedInBefore", "true", {
        // domain: "3.108.120.207",
      });
      history.push("/store");
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!snuId.includes("@snu.edu.in")) {
      alert("Please enter a valid SNU email address");
      setSnuId("");
      setPassword("");
      return;
    }
    setIsLoading(true);
    let res = await signup(snuId, password, name, referralCode, mobile);
    setIsLoading(false);
    if (res.error) {
      alert(res.error.message);
    } else {
      setName("");
      setPassword("");
      setSnuId("");
      console.log(res);
      setLoginState(true);
      alert(
        "Email verification link has been sent to you on the provided email address. Please verify your email address to continue."
      );
    }
  };

  return (
    <div className="login-page-container">
      <Helmet>
        <title>loginPage - DeliBuddy</title>
        <meta property="og:title" content="loginPage - DeliBuddy" />
      </Helmet>
      {loginState ? (
        <div className="login-page-container1">
          <span className="login-page-text">
            <span className="login-page-text01">Login</span>
            <br></br>
          </span>
          {isLoading && loadingIcon()}
          <form className="login-page-form" onSubmit={handleLogin}>
            <input
              type="text"
              required
              placeholder="SNU id"
              className="login-page-textinput input login-input"
              onChange={(e) => {
                setSnuId(e.target.value.trim().toLowerCase());
              }}
              value={snuId}
            />
            <input
              type="password"
              required
              minLength="8"
              placeholder="Password"
              className="login-page-textinput input login-input"
              onChange={(e) => {
                setPassword(e.target.value.trim());
              }}
              value={password}
            />
            <div className="login-page-container2">
              <span className="login-page-text06">
                <span>
                  Don't have an account?
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span
                  className="login-page-text08"
                  onClick={() => {
                    setLoginState(false);
                  }}
                >
                  Sign up
                </span>
              </span>
            </div>
            <button className="login-page-button button" type="submit">
              <span className="login-page-text03">
                <span>Login</span>
                <br></br>
              </span>
            </button>
          </form>
          <span
            className="login-page-forgot-password"
            onClick={() => {
              if (snuId === "") {
                alert("Please enter your SNU email address");
                return;
              }
              forgotPassword(snuId.trim());
            }}
          >
            Forgot password?
          </span>
        </div>
      ) : (
        <div className="login-page-container3">
          <span className="login-page-text09">
            <span className="login-page-text10">Sign Up</span>
            <br></br>
          </span>
          <form className="login-page-form1" onSubmit={handleSignup}>
            <input
              type="text"
              required
              placeholder="Name*"
              className="login-page-textinput input login-input"
              onChange={(e) => {
                setName(e.target.value.split(' ').map(e => e.charAt(0).toUpperCase() + e.slice(1)).join(' '));
              }}
              value={name}
            />
            <input
              type="text"
              required
              placeholder="SNU id*"
              minLength="6"
              className="login-page-textinput input login-input"
              onChange={(e) => {
                setSnuId(e.target.value.trim().toLowerCase());
              }}
              value={snuId}
            />
            <input
              type="number"
              required
              placeholder="Mobile No.*"
              className="login-page-textinput input login-input"
              onChange={(e) => {
                const value = e.target.value.replace(/ /g, '');
                if (value === '' || (value.length <= 10 && /^\d+$/.test(value))) {
                  setMobile(value);
                  e.target.setCustomValidity('');
                } else {
                  e.target.setCustomValidity('Please enter a valid 10-digit mobile number.');
                }
              }}
              value={mobile.trim()}
              maxLength={10}
              inputMode="numeric"
              max={9999999999}
            />
            <input
              type="password"
              required
              minLength="8"
              placeholder="Password*"
              className="login-page-textinput input login-input"
              onChange={(e) => {
                setPassword(e.target.value.trim());
              }}
              value={password}
            />
            <input
              type="text"
              placeholder="Referral Code"
              className="login-page-textinput input login-input"
              onChange={(e) => {
                setReferralCode(e.target.value);
              }}
              value={referralCode.trim()}
            />
            <button className="login-page-button1 button" type="submit">
              <span className="login-page-text12">
                <span>{isLoading ? loadingIcon() : "Create Account"}</span>
                <br></br>
              </span>
            </button>
          </form>
          <div className="login-page-container4">
            <span className="login-page-text15">
              <span>
                Already have an account?
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span
                className="login-page-text17"
                onClick={() => {
                  setLoginState(true);
                }}
              >
                Login
              </span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
